import {useState, useEffect} from "react";
import axios from "axios";
import styles from "@/components/makes/MakesComponent.module.css";
import {authenticatedFetchAPI} from "@/pages/api/clearwattApi";

export default function MakesComponent({onMakeSelect}) {
  const [makeCounts, setMakeCounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /*useEffect(() => {
    setIsLoading(true);
    // Define the API endpoint URL
    const apiUrl = "/api/vehicles/makes/count";

    // Make the authenticated API call using the authenticatedFetchAPI function
    authenticatedFetchAPI(apiUrl)
      .then((response) => {
        // Sort the data by make in ascending order
        const sortedData = response.sort((a, b) =>
          a.make.localeCompare(b.make)
        );

        // Update the makeCounts state with the sorted data
        setMakeCounts(sortedData);

        // Set the loading state to false
        setIsLoading(false);
      })
      .catch((error) => {
        // Handle any errors that occur during the API call
        console.error("Error fetching make counts:", error);

        // Set the loading state to false
        setIsLoading(false);
      });
  }, []);*/

  useEffect(() => {
    setIsLoading(true);

    // Define the API endpoint URL using an environment variable
    const apiUrl = `${process.env.NEXT_PUBLIC_CLEARWATT_BASE_API}/vehicles/makes_group/?page_size=99`;

    // Define an async function to perform the fetch operation
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();

        // Sort the data by make in ascending order
        const sortedData = data.results.sort((a, b) => a.make.localeCompare(b.make));

        // Update the makeCounts state with the sorted data
        setMakeCounts(sortedData);
      } catch (error) {
        console.error("Error fetching make counts:", error);
      } finally {
        // Set the loading state to false
        setIsLoading(false);
      }
    };

    // Execute the fetchData function
    fetchData();
  }, []); // The dependencies array is empty, indicating this effect runs only once after the initial render

  return (
    <div className={styles.makesBlock}>
      <div className={styles.makesContainer}>
        <div className={styles.H1}>All EV Makes</div>
        {isLoading && (
          <div className={styles.loader}>
            <img
              className={styles.loaderIcon}
              alt="Loading..."
              src="icons/loading.svg"
            />
          </div>
        )}
        {!isLoading && (
          <div className={styles.makesList}>
            {makeCounts.map(({make, variant_count}) => (
              <div
                key={make}
                className={styles.makeItem}
                onClick={() => onMakeSelect(make)}>
                <span className={styles.makeText}>{make}</span>{" "}
                <span className={styles.countText}>({variant_count})</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
